// Platform detection + keyboard label helpers.
// The bindings always check both metaKey and ctrlKey, so shortcuts work
// everywhere — these helpers only control how chord labels are *displayed*.

export const isMac =
  typeof navigator !== 'undefined' &&
  /mac/i.test(
    (navigator as Navigator & { userAgentData?: { platform?: string } })
      .userAgentData?.platform ?? navigator.platform
  );

export const MOD = isMac ? '⌘' : 'Ctrl';
export const SHIFT = isMac ? '⇧' : 'Shift';
export const ALT = isMac ? '⌥' : 'Alt';

const SEP = isMac ? '' : '+';

/** Format a keychord for display. `chord('mod','shift','N')` → "⌘⇧N" on Mac, "Ctrl+Shift+N" on Windows. */
export function chord(...parts: Array<'mod' | 'shift' | 'alt' | string>): string {
  return parts
    .map((p) => {
      if (p === 'mod') return MOD;
      if (p === 'shift') return SHIFT;
      if (p === 'alt') return ALT;
      return p;
    })
    .join(SEP);
}
